import { render } from "./banner-pitch.vue?vue&type=template&id=3587fadc&scoped=true&ts=true"
import script from "./banner-pitch.vue?vue&type=script&lang=ts"
export * from "./banner-pitch.vue?vue&type=script&lang=ts"

import "./banner-pitch.vue?vue&type=style&index=0&id=3587fadc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3587fadc"]])

export default __exports__